import Write from './Write';

export default Write;
